module.exports = __webpack_public_path__ + "static/media/freshersinfo.67ee7405.pdf";